import React from "react";
import "./Footer.css";
import Github from "../../assets/github.png";
import Linkedin from "../../assets/linkedin.png";
import Instagram from "../../assets/instagram.png";
import Logo from "../../assets/logo.png";
const Footer = () => {
  return (
    <div className="Footer-container">
      <hr />
      <div className="footer">
        <div className="blur blur1"></div>
        <div className="sociallink">
            <img src={Github} alt="" />
            <img src={Linkedin} alt="" />
            <img src={Instagram} alt="" />
        </div>
      
      <div className="logo-f">
        <img src={Logo} alt="" />
      </div>
      </div>
    </div>
  );
};

export default Footer;
